import { Component, ViewEncapsulation, OnInit, Input } from "@angular/core";

@Component({
    selector: 'app-innerhtml-view',
    template: `<div [innerHTML]="preview"></div>`,
    standalone: true,
    encapsulation: ViewEncapsulation.ShadowDom
})
export class InnerHtmlViewComponent {
    @Input() preview: any;
}